var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgAwards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 104,
    viewBox: "0 0 164 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9077",
    style: {
      fill: "none"
    },
    d: "M0 0h164v104H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9313"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1950",
    d: "M2.786 29.772a14.028 14.028 0 0 0 10.539-4.064c-1.035 2.823-1.783 5.066-2.707 7.233-.218.512-1.011.8-1.575 1.14-1.516.9-3.335 1.494-4.518 2.71A16.859 16.859 0 0 0 0 47.063c4.348-1 6.872-3.845 9.362-7.641-.2 2.629-.288 4.685-.555 6.718A2.062 2.062 0 0 1 7.7 47.483c-2.138.885-3.193 2.608-4.019 4.619-1.591 3.868-2.187 8.28-1.25 10.858 3.578-2.45 5.617-5.8 6.712-10.41a34.268 34.268 0 0 1 .54 5.282 5.433 5.433 0 0 1-1.258 2.928c-2.834 3.414-3.5 11.557-1.046 15.679 2.841-2.776 3.831-6.242 4.2-10.029 1.137 2.312 2.727 4.492.438 7.051a4.317 4.317 0 0 0-.774 2.575 21.861 21.861 0 0 0 3.135 12.331c2.439-3.741 2.37-7.521 2.213-11.49.9 1.363 1.889 2.682 2.668 4.113a2.543 2.543 0 0 1 .116 2.01c-1.993 4.169-.477 7.8 1.664 11.3a42.654 42.654 0 0 0 3.211 4c1.216-4.5.327-8.214-1.065-12.492 1.911 2.306 4.2 3.358 4.616 6.206.189 1.288 1.59 2.7 2.809 3.465a57.068 57.068 0 0 0 6.733 3.163 10.519 10.519 0 0 0-7.6-9.189 8.241 8.241 0 0 1-3.72-2.217l8.313-.783a8.792 8.792 0 0 0-9.379-4.527c-3.512.809-4.115.475-5.553-3.041 1.6.313 3.211.727 4.852.92a33.932 33.932 0 0 0 3.93.03c-.62-3.087-5.186-6.555-8.617-6.108-3.716.485-3.428-.208-4.8-3.208-.282-.616-.485-1.269-.735-1.933l8.659 3.982c-.222-4.3-4.217-9.314-8.009-9.817-2.328-.308-3.135-1.409-3.351-3.476-.123-1.17-.4-2.324-.62-3.525l7.911 7.139c.847-4.175-1.717-10.016-5.111-12.327-3.556-2.42-4.07-3.9-2.852-8.089l6.262 9.127.587-.3c.84-4.62.134-8.984-2.873-12.75-3.1-3.879-3.3-5.039-.931-9.516L17.22 39.67l.724-.141a15.98 15.98 0 0 0 .3-13.657c-1.8-3.991-1.823-4.37 1.251-7.8l.818 11.144.582.156A11.941 11.941 0 0 0 22.07 28.1c2.617-3.765 3.719-7.93 2.437-12.373-.658-2.28-.235-3.751 1.658-5 .931-.612 1.789-1.334 2.91-2.179-.6 2.037-1.2 3.76-1.589 5.529-.406 1.822-.611 3.688-.917 5.621 3.737-.935 6.943-5.215 7.338-9.55.411-4.519.412-4.515 4.908-5.869.457-.138.891-.354 1.869-.75a7.28 7.28 0 0 0-1.784-.838 2.872 2.872 0 0 0-1.412.351c-2.173 1-3.7.732-5.665-1.11C28.911-.8 25.026-.147 21.433.928a26.093 26.093 0 0 0-3.56 1.7A14.175 14.175 0 0 0 28.985 6.71C27.316 8 26.118 9.041 24.8 9.888a2.169 2.169 0 0 1-1.9.206c-3.1-2.217-6.208-1.4-9.161.043a49.046 49.046 0 0 0-5.816 3.971c4.261 2.271 7.9 2.147 12.13.556-1.385 1.986-2.385 3.607-3.6 5.049a2.4 2.4 0 0 1-2.016.569 6.688 6.688 0 0 0-5.77 1.271c-2.742 2.015-5 4.438-5.878 8.22",
    transform: "rotate(-171 78.366 46.05)",
    style: {
      fill: "#498d4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1951",
    d: "M2.786 68.872a14.028 14.028 0 0 1 10.539 4.064c-1.035-2.823-1.783-5.066-2.707-7.233-.218-.512-1.011-.8-1.575-1.14-1.516-.9-3.335-1.494-4.518-2.71A16.859 16.859 0 0 1 0 51.581c4.348 1 6.872 3.845 9.362 7.641-.2-2.629-.288-4.685-.555-6.718A2.062 2.062 0 0 0 7.7 51.161c-2.138-.885-3.193-2.608-4.019-4.619-1.59-3.868-2.186-8.279-1.249-10.857 3.578 2.45 5.617 5.8 6.712 10.41a34.268 34.268 0 0 0 .54-5.282 5.433 5.433 0 0 0-1.258-2.928c-2.834-3.414-3.5-11.557-1.046-15.679 2.841 2.776 3.831 6.242 4.2 10.029 1.137-2.312 2.727-4.492.438-7.051a4.317 4.317 0 0 1-.774-2.575 21.861 21.861 0 0 1 3.135-12.331c2.439 3.741 2.37 7.521 2.213 11.49.9-1.363 1.889-2.682 2.668-4.113a2.543 2.543 0 0 0 .112-2.012c-1.993-4.169-.477-7.8 1.664-11.3a42.653 42.653 0 0 1 3.211-4c1.216 4.5.327 8.214-1.065 12.492 1.911-2.306 4.2-3.358 4.616-6.206.189-1.288 1.59-2.7 2.809-3.465A57.066 57.066 0 0 1 37.343 0a10.519 10.519 0 0 1-7.6 9.189 8.241 8.241 0 0 0-3.72 2.217l8.313.783a8.792 8.792 0 0 1-9.379 4.527c-3.512-.809-4.115-.475-5.553 3.041 1.6-.313 3.211-.727 4.852-.92a33.932 33.932 0 0 1 3.93-.03c-.62 3.087-5.186 6.555-8.617 6.108-3.716-.485-3.428.208-4.8 3.208-.282.616-.485 1.269-.735 1.933l8.659-3.982c-.222 4.3-4.217 9.314-8.009 9.817-2.328.308-3.135 1.409-3.351 3.476-.123 1.17-.4 2.324-.62 3.525l7.911-7.139c.847 4.175-1.717 10.016-5.111 12.327-3.556 2.42-4.07 3.9-2.852 8.089l6.261-9.126.587.3c.84 4.62.134 8.984-2.873 12.75-3.1 3.879-3.3 5.039-.931 9.516l3.516-10.639.724.141a15.98 15.98 0 0 1 .3 13.657c-1.8 3.991-1.823 4.37 1.251 7.8l.818-11.144.582-.156a11.942 11.942 0 0 1 1.178 1.271c2.617 3.765 3.719 7.93 2.437 12.373-.658 2.28-.235 3.751 1.658 5 .931.612 1.789 1.334 2.91 2.179-.6-2.037-1.2-3.76-1.589-5.529-.406-1.822-.611-3.688-.917-5.621 3.737.935 6.943 5.215 7.338 9.55.411 4.519.412 4.515 4.908 5.869.457.138.891.354 1.869.75a7.28 7.28 0 0 1-1.779.841 2.872 2.872 0 0 1-1.412-.351c-2.173-1-3.7-.732-5.665 1.11-2.917 2.731-6.8 2.081-10.395 1.006a26.1 26.1 0 0 1-3.56-1.7 14.175 14.175 0 0 1 11.112-4.078c-1.669-1.29-2.867-2.331-4.19-3.178a2.169 2.169 0 0 0-1.9-.206c-3.1 2.217-6.208 1.4-9.161-.043a49.047 49.047 0 0 1-5.816-3.971c4.261-2.271 7.9-2.147 12.13-.556-1.385-1.986-2.385-3.607-3.6-5.049a2.4 2.4 0 0 0-2.016-.569 6.688 6.688 0 0 1-5.77-1.271c-2.742-2.015-5-4.438-5.878-8.22",
    transform: "rotate(-9 40.431 3.182)",
    style: {
      fill: "#498d4b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1043"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1016"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 615",
    d: "M236.986 368.29h-12.748l2.9-18.389h6.954z",
    transform: "translate(-148.736 -283.536)",
    style: {
      fill: "#f7cc19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 616",
    d: "M230.225 301.678a7.649 7.649 0 1 0-7.649 7.649 7.649 7.649 0 0 0 7.649-7.649",
    transform: "translate(-140.698 -235.314)",
    style: {
      fill: "#fab100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 617",
    d: "M61.954 102.745H12.2a12.2 12.2 0 0 1 0-24.39h49.754a12.2 12.2 0 0 1 0 24.39M12.2 82.5a8.049 8.049 0 0 0 0 16.1h49.754a8.049 8.049 0 0 0 0-16.1z",
    transform: "translate(44.802 -49.167)",
    style: {
      fill: "#fab100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 645",
    transform: "translate(58.257 29.188)",
    style: {
      fill: "#fa9700"
    },
    d: "M0 0h47.238v4.147H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 618",
    d: "M146.513 226.218H99.649a23.435 23.435 0 0 0 .895 4.147h45.074a23.434 23.434 0 0 0 .895-4.147",
    transform: "translate(-41.204 -176.787)",
    style: {
      fill: "#fa9700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 619",
    d: "M134.9 72.985a21.557 21.557 0 0 1-21.557-21.557V27.089h43.114v24.339A21.557 21.557 0 0 1 134.9 72.985",
    transform: "translate(-53.023 -4.92)",
    style: {
      fill: "#f7cc19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 620",
    d: "M138 89.34h-2.19a.95.95 0 0 1-.95-.95V67.58a.95.95 0 0 1 .95-.95H138a.95.95 0 0 1 .95.95v20.81a.95.95 0 0 1-.95.95",
    transform: "translate(-71.594 -39.048)",
    style: {
      fill: "#f9dc3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 621",
    d: "M126.885 0H78.616a2.522 2.522 0 0 0-2.522 2.522V4.9a2.522 2.522 0 0 0 2.522 2.522h48.269a2.522 2.522 0 0 0 2.522-2.522V2.522A2.522 2.522 0 0 0 126.885 0",
    transform: "translate(-20.874 18.46)",
    style: {
      fill: "#fab100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 646",
    transform: "translate(60.723 19.109)",
    style: {
      fill: "#fcc645"
    },
    d: "M0 0h6.63v5.981H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 647",
    transform: "translate(69.369 19.109)",
    style: {
      fill: "#fcc645"
    },
    d: "M0 0h2.754v5.981H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 622",
    d: "m197.41 106.964 2.464 4.993a1.551 1.551 0 0 0 1.168.848l5.51.8a1.551 1.551 0 0 1 .86 2.645l-3.987 3.886a1.551 1.551 0 0 0-.446 1.373l.941 5.487a1.551 1.551 0 0 1-2.25 1.635l-4.928-2.591a1.551 1.551 0 0 0-1.443 0l-4.928 2.591a1.551 1.551 0 0 1-2.25-1.635l.941-5.487a1.55 1.55 0 0 0-.446-1.373l-3.987-3.886a1.551 1.551 0 0 1 .86-2.645l5.51-.8a1.551 1.551 0 0 0 1.168-.848l2.464-4.993a1.551 1.551 0 0 1 2.782 0",
    transform: "translate(-114.142 -73.113)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 623",
    d: "M177.246 460.514h-20.4a6.258 6.258 0 0 0-6.259 6.259 3.013 3.013 0 0 0 3.013 3.013h26.888a3.013 3.013 0 0 0 3.013-3.013 6.258 6.258 0 0 0-6.259-6.259",
    transform: "translate(-85.17 -379.005)",
    style: {
      fill: "#fab100"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAwards);
export default __webpack_public_path__ + "static/media/img_awards.201a1d5d6de8933cd3981fd283d900de.svg";
export { ForwardRef as ReactComponent };